import React, { useState } from 'react'
import { Box, ClickAwayListener, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import translations from './image-translations.json'

// The browser always loads the untouched original. Only transparent SVG hit areas
// are added; normalized coordinates follow the image at every display size.
export default function TranslatableImage({ src, alt, style, className, card = false }) {
  const [active, setActive] = useState(null)
  const regions = translations[src] || []
  return (
    <ClickAwayListener onClickAway={() => setActive(null)}>
      <Box className={className} style={style} sx={{ position: 'relative', width: '100%' }}>
        <img src={src} alt={alt || 'Project screenshot'} style={{ display: 'block', width: '100%', height: 'auto' }} />
        {regions.length > 0 && (
          <Box component="svg" viewBox="0 0 1000 1000" preserveAspectRatio="none"
            aria-label="English translations of Korean text"
            sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', overflow: 'hidden', pointerEvents: 'none' }}>
            {regions.map((region, index) => (
              <Tooltip key={index} title={
                <Box data-translation-content sx={region.paragraph ? { maxHeight: 'min(360px, 45vh)', overflowY: 'auto', overflowX: 'hidden', pr: 0.5 } : {}}>
                  {region.english}
                </Box>
              } arrow placement="top"
                open={active === index} onOpen={() => setActive(index)} onClose={() => setActive(null)}
                enterDelay={150} leaveDelay={region.paragraph ? 250 : 0} enterTouchDelay={0} leaveTouchDelay={4000}
                componentsProps={{ tooltip: { sx: { fontSize: 14, lineHeight: 1.6, maxWidth: region.paragraph ? 440 : 360, px: 1.5, py: 1, whiteSpace: 'pre-line' } } }}>
                <Box component="polygon" points={region.points} role="button" tabIndex={card ? -1 : 0}
                  aria-label={region.english}
                  onClick={(event) => { if (!card) { event.stopPropagation(); setActive(index) } }}
                  onKeyDown={(event) => {
                    if (event.key === 'Escape' && active !== null) { event.stopPropagation(); setActive(null) }
                    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); setActive(index) }
                  }}
                  sx={{ fill: 'transparent', stroke: 'transparent', pointerEvents: 'all', cursor: 'help', outline: 'none',
                    '&:hover, &:focus-visible': { fill: 'rgba(32, 101, 209, 0.06)', stroke: 'rgba(32, 101, 209, 0.45)', strokeWidth: 1, vectorEffect: 'non-scaling-stroke' } }}
                />
              </Tooltip>
            ))}
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  )
}

TranslatableImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  card: PropTypes.bool,
}
